<template>
  <div id="app">
      <router-view></router-view>
      <div class="sd-player"></div>
      <sd-confirm ref="confirm"></sd-confirm>
  </div>
</template>
<style lang="scss">
    @import "assets/sass/auth";
</style>
<script type="es6">
import { mapState, mapActions } from 'vuex'
import './service/jqEx'
import { auth } from './service/auth'
//import './assets/css/auth.css'
import './assets/css/public.css'
import './assets/css/player.css'
import './assets/css/font-awesome.min.css'
import { gPlayer } from './plug/playerController'
import sdConfirm from './components/sdConfirm'

export default {
  name: 'app',
  components: { sdConfirm },
  data() {
    return { 
      temp : 'asdasd',
    }
  },
  computed: {
    ...mapState({
          soundData : state => state.common.soundData,
      })
  },
  methods: {
    
  },
  mounted(){
    gPlayer.initPlayer(this.soundData);
    auth.register.bind();
    let _this = this;
    // 挂载弹框组件
    util.confirm = this.$refs.confirm;
    // window.vue.$confirm = this.$refs.confirm;
  },
  created(){
    
  }
}
</script>

<style lang="scss">
 

</style>



// WEBPACK FOOTER //
// App.vue?b15b330e